import { ref } from 'vue';
import { type RouteLocationNormalizedLoadedGeneric } from 'vue-router';
import { router } from '@/router';
import { usePageMeta } from '@/utils/hooks/useTitle';
import { currentSiteName } from '@/utils/tools';

const tdkData: any = ref({});

const formatTDKDatas = (tdkData: any) => {
  // 结构面包屑位置
  const { projectName, discusName, discusContent, orgName, orgDescription, projectNames, projectDescription, breadcrumb, issueTitle, updatedTime, userNickname, userID, userDesc } = tdkData;

  // 兼容null和undefined场景
  const repoDescriptionFormat = projectDescription ? `${projectDescription}` : '';
  const orgDescFormat = orgDescription ? `${orgDescription}` : '';
  const userDescFormat = userDesc ? `${userDesc}` : '';
  const issueTitleFormat = issueTitle ? `${issueTitle}` : 'issue';
  return {
    'repoWiki': {
      T: `${projectName} - Wiki`,
      D: `${projectName} - Wiki频道为您提供 ${projectName} 相关的介绍信息,包括项目使用教程,项目开发说明,项目常见问题等.`,
      K: `${projectName} -  Wiki,${currentSiteName()}`
    },
    'repoWikiDetail': {
      T: `${projectName} - Wiki`,
      D: `${projectName} - Wiki频道为您提供 ${projectName} 相关的介绍信息,包括项目使用教程,项目开发说明,项目常见问题等.`,
      K: `${projectName} - Wiki,${currentSiteName()}`
    },
    'repoDiscussion': {
      T: `${projectName} - 讨论`,
      D: `${projectName} - 讨论频道您可在此频道与广大程序开发者沟通交流更多 ${projectName} 相关的内容.`,
      K: `${projectName} - 讨论,${currentSiteName()}`
    },
    'repoDiscussionDetail': {
      T: `${discusName} - ${projectName}`,
      D: `${discusContent}`,
      K: `${discusName},${projectName}`
    },

    // 组织首页
    org: {
      T: `${orgName} - 开源代码托管,代码协作`,
      D: orgDescFormat,
      K: `${orgName},${currentSiteName()},开源代码托管,代码协作`
    },
    // 组织项目
    orgRepos: {
      T: `组织项目 - ${orgName}`,
      D: orgDescFormat,
      K: `${orgName},${projectNames}`
    },
    // 组织issue
    orgIssue: {
      T: `issues - ${orgName}`,
      D: orgDescFormat,
      K: `issues,${orgName}`
    },
    // 组织pr
    orgMerge: {
      T: `合并请求 - Pull Requests - ${orgName}`,
      D: orgDescFormat,
      K: `合并请求,Pull Requests,${orgName}`
    },
    orgKanban: {
      T: `看板 - ${orgName}`,
      D: orgDescFormat,
      K: `看板,${orgName}`
    },
    // repoDashboard
    repoDashboard: {
      T: projectDescription ? `${projectName}:${projectDescription}` : `${projectName}`,
      D: repoDescriptionFormat,
      K: `${projectName},${orgName}`
    },
    repoDashboardBranch: {
      T: projectDescription ? `${projectName}:${projectDescription}` : `${projectName}`,
      D: repoDescriptionFormat,
      K: `${projectName},${orgName}`
    },
    repoIssues: {
      T: `issues - ${orgName}/${projectName}`,
      D: `${projectName} issues 频道为开源项目讨论平台,您可讨论关于 ${projectName} 的建议,接受合作伙伴意见反馈或工作跟踪等,可高效进行代码协作`,
      K: `${projectName},${orgName}`
    },
    repoBranch: {
      T: `${projectName} - branches - ${orgName}`,
      D: `${projectName} - branches频道页为您提供 ${projectName} 代码框架,让您详细的了解开源代码层次结构.`,
      K: `${projectName},${orgName},${currentSiteName()}`
    },
    repoDir: {
      T: `${breadcrumb} · ${orgName}/${projectName}`,
      D: repoDescriptionFormat,
      K: `${projectName},${orgName},${currentSiteName()}`
    },
    repoFile: {
      T: `${breadcrumb} · ${orgName}/${projectName}`,
      D: repoDescriptionFormat,
      K: `${projectName},${orgName},${currentSiteName()}`
    },
    repoIssueCreate: {
      T: `新建issue - ${orgName}/${projectName}`,
      D: '',
      K: ''
    },
    repoIssueDetail: {
      T: `${issueTitleFormat} - ${orgName}/${projectName}`,
      D: `${projectName} issue 更新于 ${updatedTime} ,参与讨论并深入探讨 ${projectName} 中的问题及问题状态跟踪`,
      K: `${orgName},${projectName}`
    },
    repoIssueCreateChoose: {
      T: `issue模板选择 - ${orgName}/${projectName}`,
      D: '',
      K: ''
    },
    repoAnalysis: {
      T: `仓库统计 - ${orgName}/${projectName}`,
      D: repoDescriptionFormat,
      K: `${orgName},${projectName}`
    },
    repoMerge: {
      T: `合并请求 - Pull Requests - ${orgName}/${projectName}`,
      D: repoDescriptionFormat,
      K: `${orgName},${projectName}`
    },
    repoGraph: {
      T: `仓库分支图 - ${orgName}/${projectName}`,
      D: repoDescriptionFormat,
      K: `${orgName},${projectName}`
    },
    userStars: {
      T: `${userNickname}(${userID}) - Star列表`,
      D: `${userNickname} - Star列表,了解 ${userNickname} 关注的星级项目清单.`,
      K: `${userNickname} - Star列表,开源社区,开源代码`
    },
    userRepos: {
      T: `${userNickname}(${userID}) - 项目页`,
      D: `${userNickname}的项目列表,了解 ${userNickname} 关注的项目代码和作品.`,
      K: `${userNickname},项目页,开源社区,开源代码`
    },
    homepage: {
      T: `${userNickname}(${userID})`,
      D: userDescFormat,
      K: `${userNickname},开源社区,开源代码`
    }
  };
};

export function useTDK(tdkData: Record<string, any>, route: RouteLocationNormalizedLoadedGeneric) {
  let routeName = route?.name as string;
  // 组织的主页的routeName是homepage，所以需要特殊处理，通过meta.pageType以及传入参数判断
  if (route?.name === 'homepage' && route?.meta?.pageType === 'userOrOrg' && tdkData?.orgName) {
    routeName = 'org';
  }
  if (!routeName || !(routeName in formatTDKDatas(tdkData))) {
    return {
      updateTDK: () => { }
    };
  }
  const { T, D, K } = formatTDKDatas(tdkData)[routeName as keyof typeof formatTDKDatas] || { T: '', D: '', K: '' };

  return {
    updateTDK: () => {
      usePageMeta({
        title: T,
        description: D,
        keywords: K
      });
    }
  };
}

/**
 * 获取当前路由信息
 * @returns 当前路由对象
 */
export function getCurrentRoute() {
  return router.currentRoute.value;
}

export function useTDKData(to?: RouteLocationNormalizedLoadedGeneric) {
  return {
    tdkData,
    setTDKData: (data: any) => {
      tdkData.value = { ...tdkData.value, ...data };
      // 在setup外获取项目的路由
      const currentRoute = to || getCurrentRoute();
      if (currentRoute) {
        const { updateTDK } = useTDK(tdkData.value, currentRoute);
        updateTDK?.();
      }
    }
  };
}

